import { render, staticRenderFns } from "./Heart_selection.vue?vue&type=template&id=22f03bce&scoped=true"
import script from "./Heart_selection.vue?vue&type=script&lang=js"
export * from "./Heart_selection.vue?vue&type=script&lang=js"
import style0 from "./Heart_selection.vue?vue&type=style&index=0&id=22f03bce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f03bce",
  null
  
)

export default component.exports